import React, { useCallback, useMemo } from 'react';
import Slider from 'react-slick';
import { useHomePage } from './talons/useHomePage';
import { Card } from 'components/ui';
import cardImg from './assests/card.png';
import { IoIosArrowBack } from 'react-icons/io';
import { IoIosArrowForward } from 'react-icons/io';
import { IoSearch } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui';

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className="absolute sm:top-[-68px] top-[-33px] sm:right-[36px] right-[0px] flex sm:justify-end justify-start w-full sm:mt-[0px] mt-4">
      <div
        className="border-2 border-solid border-teal-500 p-2 rounded-lg cursor-pointer"
        onClick={onClick}
      >
        <IoIosArrowBack color={'#14B8A6'} />
      </div>
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className="sm:absolute relative sm:top-[-68px] top-[-17px] sm:right-[0px] right-[-39px] flex sm:justify-end justify-start w-[200px] sm:mt-[0px] mt-4">
      <div
        className="border-2 border-solid border-teal-500 p-2 rounded-lg cursor-pointer"
        onClick={onClick}
      >
        <IoIosArrowForward color={'#14B8A6'} />
      </div>
    </div>
  );
};

const Specialties = () => {
  const { specialties } = useHomePage();
  const navigate = useNavigate();

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // const cardHeader = useCallback((item) => {
  //   return (
  //     <div className="rounded-tl-lg rounded-tr-lg overflow-hidden">
  //       <img src={cardImg} alt="card header" className="object-cover w-full" />
  //     </div>
  //   );
  // }, []);

  const cardFooter = (specialtie) => {
    return (
      <Button
        size="md"
        variant="solid"
        onClick={() => navigate(`/results/${specialtie}`)}
        className="w-full flex items-center justify-center gap-2 shadow shadow-inner"
      >
        <IoSearch size={15} color={'white'} />
        <p className="text-xs font-bold ">Agendar sua consulta</p>
      </Button>
    );
  };

  return (
    <div className="w-full flex justify-center">
      <div className="lg:max-w-screen-2xl lg:py-28 p-4 w-full">
        <div className="">
          <h1 className="w-full text-teal-800 font-bold mb-9 font-sans lg:text-5xl text-3xl">
            Nossas Áreas
          </h1>
          <h1 className="w-full text-teal-800 font-bold mb-9 font-sans lg:text-5xl text-3xl -mt-8">
            Dermatológicas
          </h1>
        </div>

        <div>
          <Slider {...settings}>
            {specialties
              ?.filter(({ specialty }) => specialty !== 'Sem escolha')
              .map((item) => {
                return (
                  <div className="p-1">
                    <Card
                      clickable
                      className="border-none "
                      header={
                        <div className="rounded-tl-lg rounded-tr-lg overflow-hidden">
                          <img
                            src={item.img}
                            alt="card header"
                            className="object-cover h-[200px] w-full"
                          />
                        </div>
                      }
                      footer={cardFooter(item.specialty)}
                      headerClass="p-0"
                      footerBorder={false}
                      headerBorder={false}
                    >
                      <h5 className="min-h-[90px] font-bold text-teal-800">
                        {item.specialty}
                      </h5>
                      <p className="min-h-[120px] overflow-hidden mt-4">
                        {item.derma_type}
                      </p>
                    </Card>
                  </div>
                );
              })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Specialties;
